import { useDispatch } from "react-redux";
import { deleteProcedure } from "../../../API/store/actions/procedure/procedure";
import {
  deleteActivity,
  deleteActivityProcedure,
  deleteMilestone,
  deleteProject,
} from "../../../API/store/actions/projects/projects";
import {
  deleteSubTask,
  deleteSubTaskProc,
  deleteTask,
} from "../../../API/store/actions/tasks";
import Button from "../../sharedComponents/buttons/button";
import * as actionTypes from "../../../API/store/actions/actionTypes";
import { deleteDiscussion } from "../../../API/store/actions/discussion/discussion";
import { useNavigate } from "react-router-dom";
import {
  getCurrentLangFromRedux,
  getDir,
} from "../../../algorithms/styleChanges";
import { deletePost } from "../../../API/store/actions/auth";
import {
  deleteNotification,
  resendNotification,
} from "../../../API/store/actions/sharek";

const DeleteProcAlert = ({
  setVisible,
  procId,
  setProcAdded,
  procAdded,
  content,
  taskId,
  projectId,
  activityId,
  milestoneId,
  activityProcId,
  discussionId,
  subTaskId,
  subProcId,
  userToken,
  internal,
  postId,
  notificationId,
  resendNotificationId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" />
      <div className="my-2">{content}</div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={getDir(getCurrentLangFromRedux()) == "rtl" ? "نعم" : "Yes"}
          buttonStyleType={"solid"}
          onClick={async () => {
            let res;
            if (taskId) res = await deleteTask(taskId, userToken);
            else if (procId) deleteProcedure(procId, userToken);
            else if (projectId) res = await deleteProject(projectId, userToken);
            else if (activityId)
              res = await deleteActivity(activityId, userToken);
            else if (milestoneId) deleteMilestone(milestoneId, userToken);
            else if (activityProcId)
              deleteActivityProcedure(activityProcId, userToken);
            else if (discussionId) deleteDiscussion(discussionId, userToken);
            else if (postId) deletePost(postId, userToken);
            else if (subTaskId) deleteSubTask(subTaskId, userToken);
            else if (notificationId)
              deleteNotification(notificationId, userToken);
            else if (resendNotificationId)
              resendNotification(resendNotificationId, userToken);
            else if (subProcId) deleteSubTaskProc(subProcId, userToken);
            dispatch({ type: actionTypes.RELOAD });
            if (internal && res.status <= 206) {
              navigate(-1);
            }
            setProcAdded(!procAdded);
            setVisible(false);
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={getDir(getCurrentLangFromRedux()) == "rtl" ? "لا" : "No"}
          onClick={() => {
            setVisible(false);
          }}
        />
      </div>
    </div>
  );
};

export default DeleteProcAlert;
